import { create } from 'zustand'
import { useTabsStore, MAX_OPEN_TABS } from '@/stores/tabsStore'

interface TabLimitStore {
  open: boolean
  pendingUrl: string | null
  /** Exibe o diálogo e guarda a URL que o usuário tentou abrir. */
  show: (pendingUrl: string) => void
  /** Fecha o diálogo e descarta a URL pendente. */
  hide: () => void
}

export const useTabLimitStore = create<TabLimitStore>((set) => ({
  open: false,
  pendingUrl: null,
  show: (pendingUrl) => set({ open: true, pendingUrl }),
  hide: () => set({ open: false, pendingUrl: null }),
}))

/**
 * Helper reutilizável: navega direto se houver espaço, ou exibe o diálogo
 * de limite para que o usuário feche uma aba antes de abrir o novo projeto.
 *
 * @param navigate  função `navigate` do react-router
 * @param url       URL de destino (editor do projeto)
 * @param alreadyOpen  true quando o projeto já está em uma aba aberta
 */
export function navigateOrShowTabLimit(
  navigate: (url: string) => void,
  url: string,
  alreadyOpen = false,
) {
  const tabs = useTabsStore.getState().tabs
  if (!alreadyOpen && tabs.length >= MAX_OPEN_TABS) {
    useTabLimitStore.getState().show(url)
  } else {
    navigate(url)
  }
}
